import React from "react";
import MainLayout from "../../../components/Layouts";
import ShopReturnOrdersList from "../../../components/Orders/MyReturnOrderList";

const myShopReturnOrderPage = () => {
  return (
    <MainLayout>
      <ShopReturnOrdersList />
    </MainLayout>
  );
};

export default myShopReturnOrderPage;
